/**
 * An object representing the paths for different screens in the application.
 *
 * @constant {Object}
 * @property {string} home - The path for the home screen.
 * @property {string} landDetails - The path for the land details screen.
 * @property {string} lands - The path for the lands listing screen.
 * @property {string} contactUs - The path for the contact us screen.
 */
export const screens = {
  home: "/",
  landDetails: "/land-for-sale/:id", // Can accept both numeric IDs and slugs (title-123)
  lands: "/land-for-sale",
};
